import React from 'react';
import resources from '../../resources';
import AnimatedNumber from './AnimatedNumber';

class StatItem4 extends React.Component {
    render() {
        const {
            iconName,      // string (icon image src)
            value,         // string or number, ví dụ +200
            message1,      // string: đoạn text dài bên phải
            colorValue = '#E0582C',
            colorMessage1 = '#212121',
            bgColor = '#EDF8FF',
            bgColor2 = '#F5FBFF', // ✅ mặc định bgColor2
        } = this.props;

        const iconStyle = {
            width: 60,
            height: 60,
            objectFit: 'contain',
        };

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: bgColor,
                borderRadius: 20,
                padding: 10,
                paddingLeft: 16,
                background: `linear-gradient(to right, ${bgColor}, ${bgColor2})`, // ✅ sử dụng gradient
                width: 'calc(100% - 30px)',  // trừ đi padding
                height: 'calc(100% - 12px)',  // trừ đi padding
            }}>
                {/* Icon bên trái */}
                <img src={resources.icons[iconName]} alt="icon" style={iconStyle} />

                {/* Nội dung bên phải */}
                <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column' }}>
                    <div style={{fontFamily:'Inter28-SemiBold', fontSize: 36, fontWeight: 600, color: colorValue, lineHeight: 1 }}>
                      {Number.isInteger(value) ? <AnimatedNumber value={value} /> : value}  
                    </div>
                    <div style={{ fontSize: 16, fontFamily:'Inter28-SemiBold', color: colorMessage1,lineHeight: 1.4 ,  textAlign:'left' }}>
                        {message1}
                    </div>
                </div>
            </div>
        );
    }
}

export default StatItem4;
